import {DashboardLayout} from "components/Layout";
import {isMobile} from "react-device-detect";
import {useHistory, useLocation} from "react-router-dom";
import {Tab, TabList, TabPanel, Tabs} from "react-tabs";

import {TabReportComment} from "./TabReportComment";
import {TabReportStatus} from "./TabReportStatus";

const findTabIndex = tab => {
	switch (tab) {
		case "comment":
			return 1;
		default:
			return 0;
	}
};

const findTabLabel = index => {
	switch (index) {
		case 1:
			return "comment";
		default:
			return "status";
	}
};

const ReportStatusListPage = () => {
	const history = useHistory();
	const location = useLocation();
	const activeTab = new URLSearchParams(location?.search).get("tab");
	const tab = findTabIndex(activeTab);

	const handleSelectTab = index => {
		history.push(`/report-status?tab=${findTabLabel(index)}`);
	};

	return (
		<DashboardLayout>
			<Tabs className="mb-0" selectedIndex={tab} onSelect={handleSelectTab}>
				<div class="" style={isMobile ? {"overflow-x": "auto", "white-space": "nowrap"} : {}}>
					<TabList className="border-0">
						<Tab>Report Status</Tab>
						<Tab>Report Comment</Tab>
					</TabList>
				</div>

				<div className="box-white setting-content h-100 no-border p24">
					<TabPanel>
						<TabReportStatus />
					</TabPanel>
					<TabPanel>
						<TabReportComment />
					</TabPanel>
				</div>
			</Tabs>
		</DashboardLayout>
	);
};

export {ReportStatusListPage};
